var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRecentlyUsed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.75,40A16.75,16.75,0,1,0,40,56.75,16.76915,16.76915,0,0,0,56.75,40Zm-32,0A15.25,15.25,0,1,1,40,55.25,15.26751,15.26751,0,0,1,24.75,40Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.53027,43.46973,40.75,39.68945V28h-1.5V40a.75027.75027,0,0,0,.21973.53027l4,4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40,70.75a30.75,30.75,0,0,0,0-61.5,30.47112,30.47112,0,0,0-21.25,8.53192V12h-1.5v8a.7502.7502,0,0,0,.75.75h8v-1.5H19.39722A28.99145,28.99145,0,0,1,40,10.75,29.25,29.25,0,1,1,10.75,40a28.92622,28.92622,0,0,1,3.26709-13.44678l-1.332-.69043A30.7615,30.7615,0,0,0,40,70.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecentlyUsed);
export default __webpack_public_path__ + "static/media/icon_recently_used.5e2a83784dfd19e45a2fb3e210fba85b.svg";
export { ForwardRef as ReactComponent };